export const TZ = "America/Merida";
export const TIPOS_UNIDAD = ["Nuevo", "Seminuevo", "Sin definir"];
const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

function parts(date) {
  const p = {};
  new Intl.DateTimeFormat("en-US", {
    timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hour12: false, weekday: "short",
  }).formatToParts(date).forEach(({ type, value }) => { p[type] = value; });
  return p;
}

function toDate(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

// "29 oct 2026, 4:27 p. m." en hora de Mérida
export function formatIngreso(iso) {
  const d = toDate(iso);
  if (!d) return "Sin fecha";
  const p = parts(d);
  const h24 = Number(p.hour) % 24;
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${Number(p.day)} ${MESES[Number(p.month) - 1]} ${p.year}, ${h12}:${p.minute} ${h24 < 12 ? "a. m." : "p. m."}`;
}

// Día calendario (YYYY-MM-DD) en Mérida
export function meridaDay(date) {
  const p = parts(date);
  return `${p.year}-${p.month}-${p.day}`;
}

function shiftDay(ymd, days) {
  const d = new Date(`${ymd}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function periodRange(period, desde, hasta, now = new Date()) {
  const today = meridaDay(now);
  if (period === "hoy") return [today, today];
  if (period === "semana") {
    const idx = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].indexOf(parts(now).weekday);
    const lunes = shiftDay(today, -idx);
    return [lunes, shiftDay(lunes, 6)];
  }
  if (period === "mes") {
    const ym = today.slice(0, 7);
    const next = new Date(`${ym}-01T12:00:00Z`);
    next.setUTCMonth(next.getUTCMonth() + 1);
    return [`${ym}-01`, shiftDay(next.toISOString().slice(0, 10), -1)];
  }
  if (period === "rango") return [desde || "0000-01-01", hasta || "9999-12-31"];
  return null;
}

export function inPeriod(iso, range) {
  if (!range) return true;
  const d = toDate(iso);
  if (!d) return false;
  const day = meridaDay(d);
  return day >= range[0] && day <= range[1];
}

export const tipoOf = (it) => (TIPOS_UNIDAD.includes(it.tipo_unidad) ? it.tipo_unidad : "Sin definir");
